import React, { memo } from 'react'
import { useTheme } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import {
  InfoRounded as InfoIcon,
  RefreshRounded as RefreshIcon,
} from '@material-ui/icons'

import Button from '../../atoms/inputs/button'
import Typography from '../../atoms/display/typography'
import CircularProgress from '../../atoms/feedback/circularProgress'
import useStyles from './reloadStyle'

const MoleculesSnackbarReload = (props) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <InfoIcon style={{ color: theme.palette.primary.main }} />
          <Typography
            variant="body2"
            style={{
              color: theme.palette.primary.secondary,
              marginLeft: 10,
              marginRight: 10,
            }}
          >
            {t('alerts.reloadWidgetInfo')}
          </Typography>
        </div>
        <Button
          variant="contained"
          color="primary"
          startIcon={
            props.loading ? (
              <CircularProgress size={18} style={{ color: '#fff' }} />
            ) : (
              <RefreshIcon />
            )
          }
          onClick={props.onClick}
        >
          {props.loading ? t('buttons.wait') : t('buttons.tryAgain')}
        </Button>
      </div>
    </>
  )
}

export default memo(MoleculesSnackbarReload)
